import { apiRequest } from "./axiosInstance";

export const createSettingsApi = async (body,tenantId,slug) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: `/settings/${tenantId}`,
      method: "PUT",
      data: body,

    });
    return {sucess:true,data:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};

export const getSettingsApi = async (params) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: `/settings`,
      method: "GET",
      params: params,

    });
    return {sucess:true,data:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};